import product from "@/components/product/index.vue";
import groupProduct from "@/components/group-product/index.vue";
import categoryFilter from "./components/category-filter/index.vue";
import sortSelect from "./components/sort-select/index.vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
import cloneDeep from "lodash/cloneDeep";
import { directive as onClickaway } from "vue-clickaway";
import _ from "lodash";
import dynamicsHead from "@/mixins/dynamics-head";

export default {
  name: "catalog",
  directives: {
    onClickaway: onClickaway,
  },
  mixins: [dynamicsHead],
  data() {
    return {
      loadingProducts: false,
      loadingFilters: false,
      products: [],
      filters: [],
      openFilter: false,
      storedCatalogType: null,
      paginator: {
        hasNextPage: false,
        page: 1,
        perPage: 3 * 4,
      },
      timeRemaining: {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
      },
      timerInterval: null,
      isExpired: false,
      pushModalTimeout: null,
    };
  },
  components: {
    groupProduct,
    product,
    categoryFilter,
    sortSelect,
  },
  watch: {
    async $route() {
      this.clearPushModalTimeout();

      if (this.storedCatalogType !== this.catalogType) {
        this.products = [];
        this.storedCatalogType = this.catalogType;
      }
      if (!this.loadingProducts) {
        await Promise.all([this.resetPage(), this.loadProducts()]);
        if (this.$route.query && this.$route.query.categories && this.$route.query.categories.includes("outlet")) {
          await this.fetchOutletInfo();
        }
        if (this.$route.query && this.$route.query.sale_banners) {
          await this.fetchPromotionInfo(this.$route.query.sale_banners);
        }
        this.setMetaInfo();
      }
    },
  },
  async created() {
    await Promise.all([
      this.loadFilters(),
      this.loadProducts(),
      this.fetchPage('catalog')
    ]);
    if (this.$route.query && this.$route.query.categories && this.$route.query.categories.includes("outlet")) {
      await this.fetchOutletInfo();
    }
    // if(this.page && this.page.pushes && this.page.pushes.data.length > 0 ) {
    //   const popupPush = this.page.pushes.data.find(item => item.type === 'popup');
    //   if (popupPush) {
    //     this.pushModalTimeout = setTimeout(() => {
    //       this.changePushModal({status: true, image: popupPush.image})
    //     }, 10000)
    //   }
    // }
    if (this.$route.query && this.$route.query.sale_banners) {
      await this.fetchPromotionInfo(this.$route.query.sale_banners);
      this.$nextTick(() => {
        this.startTimer();
      });
    }
    this.setMetaInfo();
    this.storedCatalogType = this.catalogType;
  },
  computed: {
    ...mapGetters({
      isAuthenticated: "auth/isAuthenticated",
      favourites: "favorites/whichList",
      outletPageInfo: "products/outletPageInfo",
      currentPromotion: "promotions/currentPromotion",
      page: "pages/page",
    }),
    formattedTimeRemaining() {
      if (this.isExpired) {
        return null;
      }
      const { days, hours, minutes, seconds } = this.timeRemaining;

      // Hide timer if everything is 0
      if (days === 0 && hours === 0 && minutes === 0 && seconds === 0) {
        return null;
      }

      const pluralizeDays = (days) => {
        const mod10 = days % 10;
        const mod100 = days % 100;
        if (mod10 === 1 && mod100 !== 11) return `${days} день`;
        if ([2, 3, 4].includes(mod10) && ![12, 13, 14].includes(mod100)) return `${days} дні`;
        return `${days} днів`;
      }

      if (days === 0) {
        return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
      }

      return `${pluralizeDays(days)} ${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    },
    isOutlet() {
      return this.$route.query && this.$route.query.categories && this.$route.query.categories.includes("outlet")
    },
    isPromotionsBanner() {
      return this.$route.query && this.$route.query.sale_banners
    },
    productsList() {
      if (!this.isAuthenticated || !this.favourites) {
        return this.products;
      }

      const favourites = _.map(this.favourites, "productId");
      const markAsSelected = product => {
        product.isFavorite = favourites.includes(product.id);
        return product;
      };

      if (this.catalogType === "table") {
        return _.map(this.products, markAsSelected);
      }

      return this.products.map(productGroup => {
        _.map(productGroup.products, markAsSelected);

        return productGroup;
      });
    },
    catalogType() {
      if (this.$route.query.catalog_type === "groups") {
        return "groups";
      }

      return "table";
    },
  },
  methods: {
    ...mapActions({
      fetchProductsForCatalog: "products/GET_PRODUCTS_FOR_CATALOG",
      fetchCatalogFilters: "products/GET_CATALOG_FILTERS",
      fetchOutletInfo: "products/GET_OUTLET_INFO",
      fetchPromotionInfo: "promotions/FETCH_PROMOTION",
      fetchPage: "pages/GET_PAGE",
    }),
    ...mapMutations({
      changePushModal: "popups/CHANGE_PUSH_MODAL",
    }),
    setMetaInfo() {
      this.setPageMetaInfo(this.page)
      if (this.$route.query && this.$route.query.brands && this.$route.query.brands.split(',').length > 1) {
        this.addNoIndexNoFollow();
      } else {
        this.removeNoIndexNoFollow()
      }
    },
    setBrandMetaInfo() {
      const firstProductBrand = this.productsList[0].brand;
      this.setPageMetaInfo(firstProductBrand)
    },
    parsePromotionEndTime(activeTo) {
      const [time, date] = activeTo.split(' ');
      const [hours, minutes, seconds] = time.split(':').map(Number);
      const [day, month, year] = date.split('-').map(Number);

      return new Date(year, month - 1, day, hours, minutes, seconds);
    },
    calculateTimeRemaining() {
      if (!this.currentPromotion?.activeTo) {
        return;
      }

      const endTime = this.parsePromotionEndTime(this.currentPromotion.activeTo);
      const now = new Date();
      const timeDiff = endTime.getTime() - now.getTime();

      if (timeDiff <= 0) {
        this.isExpired = true;
        this.timeRemaining = { days: 0, hours: 0, minutes: 0, seconds: 0 };
        if (this.timerInterval) {
          clearInterval(this.timerInterval);
          this.timerInterval = null;
        }
        return;
      }

      const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);

      this.timeRemaining = { days, hours, minutes, seconds };
      this.isExpired = false;
    },
    startTimer() {
      this.calculateTimeRemaining();
      this.timerInterval = setInterval(() => {
        this.calculateTimeRemaining();
      }, 1000);
    },
    test2() {},
    openFilters() {
      this.openFilter = !this.openFilter;
      if (this.openFilter) {
        document.getElementById("html").classList.add("hide");
      } else {
        document.getElementById("html").classList.remove("hide");
      }
    },
    openCategory(item) {
      return !!(item.isOpened ^ this.open);
    },
    changeSlideToggle() {
      this.open = !this.open;
    },
    resetFilter() {
      this.$router
        .push({
          name: "products",
          query: {
            catalog_type: this.$route.query.catalog_type,
          },
        })
        .catch(() => {});
    },
    away: function () {
      this.openFilter = !this.openFilter;
    },
    async resetPage() {
      this.paginator.page = 1;
      this.paginator.hasNextPage = false;
    },
    async loadFilters() {
      this.filters = await this.fetchCatalogFilters();
    },
    async loadProducts() {
      this.loadingProducts = true;

      let urlQuery = cloneDeep(this.$route.query);

      if (this.paginator.page === 1) {
        this.products = [];
      }
      /** @type {ICatalogFilter} */
      const catalogFilters = {
        catalog_type: urlQuery.catalog_type,
        sort_filter_type: urlQuery.sort_filter_type || "bestsellers",
        brands: urlQuery.brands,
        series: urlQuery.series,
        categories: urlQuery.categories,
        sale_banners: urlQuery.sale_banners,
        page: this.paginator.page,
        perPage: this.paginator.perPage,
      };
      const catalogData = await this.fetchProductsForCatalog(catalogFilters);

      this.products.push(...catalogData.data);

      this.paginator.hasNextPage = !!catalogData.links.next;

      this.loadingProducts = false;

      const transformedProducts = this.productsList.map(item => {
        return {
          item_id: item.productPrices.data[0].article,
          item_name: item.title,
          affiliation: "SkinOn-Cosmetics",
          coupon: "",
          discount: 0.0,
          index: 0,
          item_brand: item.brand?.title || "SkinOn",
          item_category: item.brandSeries?.title || "",
          item_category2: (() => {
            if (!this.isAuthenticated) return "unauthorized";
            if (this.isProfessional) return "professional";
            if (this.isDistributor) return "distributor";
            return "regular";
          })(),
          item_list_id: "Cosmetics",
          item_list_name: "Cosmetics",
          location_id: "ChIJIQBpAG2ahYAR_6128GcTUEo",
          price: item.productPrices.data[0].price,
          quantity: 1,
        };
      });

      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: "view_item_list",
        ecommerce: {
          item_list_id: "Cosmetics",
          item_list_name: "Cosmetics",
          items: transformedProducts,
        },
      });
    },
    async paginateProducts() {
      this.paginator.page += 1;

      await this.loadProducts();
    },
    clearPushModalTimeout() {
      if (this.pushModalTimeout) {
        clearTimeout(this.pushModalTimeout);
        this.pushModalTimeout = null;
      }
    },
  },
  beforeDestroy() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
    this.clearPushModalTimeout();
  }
};
